import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import { SwitchControl } from './StyledSwitch';

/**
 * A switch with its label, sitting flush against whatever it is laid out beside and taking the label
 * on either side. `StyledSwitch` is the same control with the label spacing MUI gives it by default.
 *
 * Props other than the ones named reach the label, so a caller can style it through `slotProps`.
 *
 * @param {Object} props - Component props.
 * @param {String} props.id - The control's id.
 * @param {Boolean} props.checked - Whether it reads as on.
 * @param {Function} props.onChange - Receives the change event.
 * @param {String} props.label - What the switch is called.
 * @param {String} props.labelPlacement - Which side the label sits on.
 * @param {Boolean} props.disabled - Renders the control unusable.
 * @param {String} props.size - small or medium.
 * @param {Object} props.sx - Styles merged onto the label row.
 *
 * @returns {React.JSX.Element}
 */
export default function FormSwitch({
  id = '',
  disabled = false,
  label = '',
  checked = false,
  labelPlacement = 'end',
  size = 'medium',
  sx = {},
  onChange = () => {},
  onClick = () => {},
  ...formControlLabelProps
}) {
  return (
    <FormControlLabel
      id={id}
      labelPlacement={labelPlacement}
      disabled={disabled}
      sx={{
        display: 'flex',
        alignItems: 'center',
        m: 0,
        gap: '12px',
        ...sx,
      }}
      label={label}
      {...formControlLabelProps}
      control={
        <SwitchControl
          checked={checked}
          onChange={onChange}
          onClick={onClick}
          size={size}
        />
      }
    />
  );
}
